import { Controller } from "stimulus";
import * as Sentry from "@sentry/browser";

export default class ApplicationController extends Controller {

  connect() {
    if (this.data.get('sessionStatus') === 'new') {
      this.page = '';
    }
    if (!window.location.href.includes('#')) {
      // Prevents the app breaking when navigating from a link not ending with the # 
      // Affects chrome, safari
      window.location.href += '#'; 
    }
    this.onPageChange();
    let self = this;
    window.onhashchange = () => self.onPageChange();
  }

  get page() {
    return window.location.hash;
  }

  set page(page) {
    window.location.hash = page;
  }

  get currencySymbol() {
    return this.data.get('currency-symbol');
  }

  get voucherValue() {
    return parseFloat(this.data.get("voucher-value"));
  }

  set voucherValue(value) {
    this.data.set("voucher-value", value.toString());
  }

  get paymentAmount() {
    return parseFloat(this.data.get("payment-amount"));
  }

  set paymentAmount(value) {
    this.data.set("payment-amount", value.toString());
  }

  get recipientMessage() {
    return this.data.get("recipient-message");
  }

  set recipientMessage(value) {
    this.data.set("recipient-message", value);
  }

  get purchaserFirstName() {
    return this.data.get("purchaser-first-name");
  }

  set purchaserFirstName(value) {
    this.data.set("purchaser-first-name", value);
  }

  get purchaserLastName() {
    return this.data.get("purchaser-last-name");
  }

  set purchaserLastName(value) {
    this.data.set("purchaser-last-name", value);
  }

  get recipientEmail() {
    return this.data.get("recipient-email");
  }

  get optionSpecificRecipientEmail() {
    if (this.sendOption == "SEND_TO_MYSELF") {
      return this.purchaserEmail;
    } else {
      return this.recipientEmail;
    }
  }

  set recipientEmail(value) {
    this.data.set("recipient-email", value);
  }

  get purchaserEmail() {
    return this.data.get("purchaser-email");
  }

  set purchaserEmail(value) {
    this.data.set("purchaser-email", value);
  }

  get bancardPublicKey() {
    return this.data.get("bancard-public-key");
  }

  get stripePaymentIntentSecret() {
    return this.data.get("stripe-payment-intent-secret");
  }

  get stripePaymentIntentId() {
    return this.data.get("stripe-payment-intent-id");
  }

  get purchaseNumber() {
    return this.data.get("purchase-number");
  }

  set purchaseNumber(purchaseNumber) {
    this.data.set("purchase-number", purchaseNumber);
  }

  get purchaseError() {
    return this.data.get("purchase-error");
  }

  set purchaseError(purchaseError) {
    this.data.set("purchase-error", purchaseError);
  }

  get serial() {
    return this.data.get("serial");
  }

  set serial(value) {
    this.data.set("serial", value);
  }

  get sendOption() {
    return this.data.get("send-option");
  }

  set sendOption(value) {
    this.data.set("send-option", value);
  }

  get voucherStyle() {
    return this.data.get("voucher-style")
  }

  updatePaymentAmount(event) {
    this.paymentAmount = event.paymentAmount;
  }

  updateVoucherValue(event) {
    this.voucherValue = event.voucherValue;
  }


  updatePurchaserEmail(event) {
    this.purchaserEmail = event.purchaserEmail;
  }

  updateRecipientEmail(event) {
    this.recipientEmail = event.recipientEmail;
  }

  updateRecipientMessage(event) {
    this.recipientMessage = event.recipientMessage;
  }

  updatePurchaserFirstName(event) {
    this.purchaserFirstName = event.name;
  }

  updatePurchaserLastName(event) {
    this.purchaserLastName = event.name;
  }
  updateSendOption(event) {
    this.sendOption = event.sendOption;
  }

  confirmVoucher(event) {
    if (event.confirmed) {
      this.browseToPayment();
    } else {
      this.browseToCheckout();
    }
  }

  updatePurchaseError(event) {
    this.purchaseError = event.purchaseError;
  }

  paymentConfirmed(event) {
    this.browseToSuccess();
  }

  browseToCheckout() {
    this.page = "";
  }

  browseToConfirm() {
    this.page = "confirm";
  }

  browseToPayment() {
    this.purchaseError = ""; //We don't want to show error again when browsing back to payment.
    this.page = "payment";
  }

  browseToSuccess() {
    this.page = "success";
  }

  doneAction() {
    window.parent.postMessage(JSON.stringify({ type: "completed" }), "*");
    window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  }

  onPageChange(hashChangeEvent) {
    switch (this.page) {
      case "":
        if (hashChangeEvent === undefined || hashChangeEvent.oldURL.includes("#")) {
          this.showCheckout();
        }
        break;
      case "#confirm":
        this.showConfirm();
        break;
      case "#payment":
        this.showPayment();
        break;
      case "#success":
        this.showSuccess();
        break;
      default:
    }
  }

  showCheckout() {
    this.show("checkout", {});
  }

  showConfirm() {
    //TODO: just  like payment, pre-post below values to store in voucher_session
    this.show("confirm", {
      paymentAmount: this.paymentAmount,
      voucherValue: this.voucherValue,
      purchaserEmail: this.purchaserEmail,
      recipientEmail: this.optionSpecificRecipientEmail,
      purchaserFirstName: this.purchaserFirstName,
      purchaserLastName: this.purchaserLastName,
      recipientMessage: this.recipientMessage,
      sendOption: this.sendOption
    });
  }

  async showPayment() {
    this.showSpinner();
    await this.createCart();
    if (this.purchaseNumber) {
      this.show("payment", {});
    } else {
      this.showCheckout();
    }
  }

  showSuccess() {
    this.show("success", {});
  }

  show(page, context) {
    let self = this;
    this.showSpinner();
    context.purchase_number = this.purchaseNumber;
    
    $.ajax({
      type: "get",
      url: `${window.location.protocol}//${window.location.host}${window.location.pathname}/${page}`,
      data: context,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      success: data => {
        $(self.element).fadeOut("slow", () => {
          self.element.innerHTML = data.html;
          $(self.element).fadeIn("slow");
        });
        self.publishPageChangeEvent(this.pageTitle(page));
      },
      error: (jqXhr, testStatus, errorThrown) => {
        Sentry.captureMessage(
          `Error transitioning to ${page} page error=${errorThrown}`
        );
        window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
      }
    });
  }

  pageTitle(pageId) {
    let title = null;
    switch (pageId) {
      case "checkout":
        title = this.data.get("checkout-title");
        break;
      case "confirm":
        title = this.data.get("summary-title");
        break;
      case "payment":
        title = this.data.get("payment-title");
        break;
      case "success":
        title = this.data.get("success-title");
        break;
    }
    return title;
  }

  showSpinner() {
    this.element.innerHTML =
      '<i class="fas fa-spinner fa-spin fa-7x mx-auto my-10 text-brand"></i>';
  }

  publishPageChangeEvent(pageTitle) {
    this.publishTitleUpdate(pageTitle);
  }

  publishTitleUpdate(title) {
    window.parent.postMessage(
      JSON.stringify({ type: "title", info: title }),
      "*"
    );
    const event = document.createEvent("CustomEvent");
    event.initCustomEvent("title-updated", true, true, null);
    event.title = title;
    this.element.dispatchEvent(event);
  }

  async createCart() {
    let data = { purchase_number: this.purchaseNumber };

    let response = await fetch(`${window.location.pathname}/payments`, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (response.status === 200) {
      let body = await response.json();
      this.purchaseNumber = body.purchase_number;
      this.data.set('stripe-payment-intent-secret', body.payment_intent_secret);
    } else {
      this.purchaseNumber = "";
    }
  }
}
